/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for PaymentController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { PaymentRequestDto, RequestOptions, PaymentResponseDto, ProcessPayDto, CorrectTrxDto } from "../models";

@Injectable({ providedIn: "root" })
export class PaymentControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    initiatePayment(paymentRequestDto: PaymentRequestDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    initiatePayment(paymentRequestDto: PaymentRequestDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    initiatePayment(paymentRequestDto: PaymentRequestDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    initiatePayment(paymentRequestDto: PaymentRequestDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/payments`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: paymentRequestDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    processPayment(processPayDto: ProcessPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    processPayment(processPayDto: ProcessPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    processPayment(processPayDto: ProcessPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    processPayment(processPayDto: ProcessPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/payments/process`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: processPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    corrigeTrx(correctTrxDto: CorrectTrxDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    corrigeTrx(correctTrxDto: CorrectTrxDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    corrigeTrx(correctTrxDto: CorrectTrxDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    corrigeTrx(correctTrxDto: CorrectTrxDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/payments/correct`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: correctTrxDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getStatusPayment(reference: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    getStatusPayment(reference: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    getStatusPayment(reference: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    getStatusPayment(reference: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/payments/status/${reference}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
